import { render } from "./DialogPurchaseWarning.vue?vue&type=template&id=14203a62&scoped=true"
import script from "./DialogPurchaseWarning.vue?vue&type=script&lang=js"
export * from "./DialogPurchaseWarning.vue?vue&type=script&lang=js"

import "./DialogPurchaseWarning.vue?vue&type=style&index=0&id=14203a62&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-14203a62"

export default script